import { FunctionComponent } from "react";

import { Icon, IconProps } from "./icon";

export const PlayCircle: FunctionComponent<IconProps> = ({ className }) => {
    return (
        <Icon className={className}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 14.25A6.25 6.25 0 0 0 14.25 8 6.242 6.242 0 0 0 8 1.75 6.25 6.25 0 0 0 1.75 8 6.25 6.25 0 0 0 8 14.25ZM8 16a8 8 0 0 0 8-8c0-4.419-3.57-8-8-8a8 8 0 0 0-8 8 8 8 0 0 0 8 8Z"
            ></path>
            <path d="M10.817 7.659A.415.415 0 0 1 11 8a.415.415 0 0 1-.183.341L7.242 10.91c-.305.218-.742.02-.742-.34V5.431c0-.36.437-.56.742-.341l3.575 2.568Z"></path>
        </Icon>
    );
};
